import { STORAGE_KEYS } from "../constants";
import type { AuthTokens, User } from "../types";

export const storage = {
  get<T>(key: string): T | null {
    if (typeof window === 'undefined') return null;
    
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error('Error getting from storage:', error);
      return null;
    }
  },

  set<T>(key: string, value: T): void {
    if (typeof window === 'undefined') return;
    
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error('Error saving to storage:', error);
    }
  },

  remove(key: string): void {
    if (typeof window === 'undefined') return;
    
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error removing from storage:', error);
    }
  },

  clear(): void {
    if (typeof window === 'undefined') return;
    
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing storage:', error);
    }
  },
};

export interface StoredAuthSession {
  user: User;
  tokens: AuthTokens;
}

export const authStorage = {
  getSession(): StoredAuthSession | null {
    const user = storage.get<User>(STORAGE_KEYS.USER);
    const access = storage.get<string>(STORAGE_KEYS.ACCESS_TOKEN);
    const refresh = storage.get<string>(STORAGE_KEYS.REFRESH_TOKEN);

    if (!user || !access || !refresh) {
      return null;
    }

    return {
      user,
      tokens: { access, refresh },
    };
  },

  saveSession(session: StoredAuthSession): void {
    storage.set(STORAGE_KEYS.USER, session.user);
    storage.set(STORAGE_KEYS.ACCESS_TOKEN, session.tokens.access);
    storage.set(STORAGE_KEYS.REFRESH_TOKEN, session.tokens.refresh);
  },

  clearSession(): void {
    storage.remove(STORAGE_KEYS.USER);
    storage.remove(STORAGE_KEYS.ACCESS_TOKEN);
    storage.remove(STORAGE_KEYS.REFRESH_TOKEN);
  },
};
